/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetHistoryPeriodModel {
    getFixupPrototypeFunction() { return BudgetHistoryPeriodModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetHistoryPeriodModel>): BudgetHistoryPeriodModel {
        let obj = Object.assign(new BudgetHistoryPeriodModel(), model);
        BudgetHistoryPeriodModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetHistoryPeriodModel>): BudgetHistoryPeriodModel {
        if (!model) return null;
        return BudgetHistoryPeriodModel.newInstance(<BudgetHistoryPeriodModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetHistoryPeriodModel) {
        if (!obj) return;

        models.BudgetHistoryPeriodModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetHistoryPeriodModel): boolean {
        Object.setPrototypeOf(obj, BudgetHistoryPeriodModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * period key to pass as the budget time period filter
     */
    value: string;

    /**
     * period to display.To shown as a month range, example Jul 2025 - Sep 2025
     */
    label: string;

}
